var exports = {
  "D": "xe533113f--a8460d--title",
};

module.exports = exports;
